import React, { useEffect, useState } from 'react'
import './pay-amount.scss'
import NormalInput from '../../common/inputs/NormalInput'
import { TbX } from 'react-icons/tb'
import Modal from '../../common/modal/Modal'
import PaymentMethod from './PaymentMethod'
import { YYYYMMDDFormat } from '../../../assets/javascript/formate-functions'
import toast from 'react-hot-toast'
import { accountingAxios } from '../../../config/axios'

const PayAmount = ({ bill_no, payable_amount, setModal }) => {

    const [childModal, setChildModal] = useState({ status: false })
    const [payments, setPayments] = useState([])
    const [paymentLater, setPaymentLater] = useState({})
    const [balanceAmount, setBalanceAmount] = useState(0)
    const [loading, setLoading] = useState('')

    const handleChange = (e) => {
        setPaymentLater({
            ...paymentLater,
            [e.target.name]: e.target.value
        })
    }

    const selectMethod = () => {
        setChildModal({
            status: true,
            title: "Choose Method",
            content: <PaymentMethod setModal={setChildModal} balanceAmount={balanceAmount} payments={payments} setPayments={setPayments} />
        })
    }

    const handleRemoveMethod = (id) => {
        setPayments((state) => state.filter(p => p?.unique_id !== id))
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const total = Number(payable_amount) || 0
        const enteredAmount = payments?.reduce((acc, cur) => acc + Number(cur?.amount || 0), 0) || 0
        const validAmount = enteredAmount + balanceAmount

        if (total < enteredAmount) {
            toast.error('Payable amount not match to entered amount')
            return;
        }

        if (validAmount !== total) {
            toast.error('Payable amount not match to entered amount and balance amount')
            return;
        }

        const question = enteredAmount === 0 ? 'You have not selected any methods, Are you ready to continue ?'
            : 'Are you ready to pay ?'

        const ask = window?.confirm(question)
        if (!ask) return;

        setLoading('pay')

        const body = {
            paid_amount: enteredAmount ?? 0,
            payment_methods: payments || [],
            promise_date: paymentLater?.balance_payment_date ?? null,
            comment: paymentLater?.balance_payment_reason ?? null
        }

        accountingAxios.post(`/v2/bill/${bill_no}/pay`, body).then((response) => {
            toast.success('Payment successfully done, Please refresh the page')
            setModal({ status: false })
        }).catch((err) => {
            toast.error(err?.message || 'Something went wrong')
        }).finally(() => {
            setLoading('')
        })

    }

    useEffect(() => {

        const total = Number(payable_amount) || 0
        const enteredAmount = payments?.reduce((acc, cur) => acc + Number(cur?.amount || 0), 0) || 0
        const balance = total - enteredAmount
        setBalanceAmount(balance)

        // eslint-disable-next-line
    }, [payments, paymentLater])

    return (
        <div className="pay-amount-container">
            <Modal modal={childModal} setModal={setChildModal} />
            <div className="amount-section">
                <p>payable Amount</p>
                <h2>{payable_amount} INR</h2>
            </div>
            <div className="payment-list-section">
                {payments?.map((v) => {
                    return <div className="payment-item" key={v?.method}>
                        <h3>{v?.method} : {v?.amount} INR</h3>
                        <TbX onClick={() => handleRemoveMethod(v?.unique_id)} />
                    </div>
                })}
            </div>
            {balanceAmount > 0 && <div className="add-method-section">
                <button onClick={selectMethod}>Choose Method</button>
            </div>}

            <form action="" onSubmit={handleSubmit}>
                {balanceAmount > 0 && <>
                    <NormalInput className={'balance-amount'} label='Balance Amount' type={'number'} name='balance_amount' value={balanceAmount || 0} isRequired={false} />
                    <NormalInput label='Promise Date *' type={'date'} name='balance_payment_date' value={paymentLater?.balance_payment_date || ''} onChangeFun={handleChange}
                        min={YYYYMMDDFormat(new Date())} />
                    <NormalInput label='Comment *' type={'text'} name='balance_payment_reason' value={paymentLater?.balance_payment_reason || ''} onChangeFun={handleChange}
                    />
                </>}

                <button type='submit' disabled={loading === 'pay'}>{loading ? 'Loading...' : 'Pay now'}</button>

            </form>
        </div>
    )
}

export default PayAmount